// ======================================================================
//
//  В этот файл выписываем функции что могут повторяться не однократно,
//  Функции cделать по возможности гибкими что бы не писать что то похожее дважды (DRY)
//
// ======================================================================

import {format, parseISO} from "date-fns";
import {enUS, ru} from "date-fns/locale";
import {initAceEditor} from "@/script/ace-editor";
import {useStore}  from "vuex";
import {getDateFnsLocale} from "@/i18n";

const months = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
]

const monthsEng = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
]
const monthsKy = [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
]

const days = [
    'Пн',
    'Вт',
    'Ср',
    'Чт',
    'Пт',
    'Сб',
    'Вс'
]

const daysEng = [
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat',
    'Sun'
]

const daysKy = [
    'Дүй',
    'Шей',
    'Шар',
    'Бей',
    'Жум',
    'Ише',
    'Жек'
]

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Форматирует дату по указанному шаблону
 *
 * @param {Int|String|null} date  Дата для форматирования (null или <timestamp>1689966000 или <string>2023-09-18 10:00:00)
 * @param {String} format Шаблон форматирования (см. https://date-fns.org/v2.30.0/docs/format)
 */
const formatDate = (date, formatStr = 'dd MMMM yyyy', locale = 'ru') => {
    let dt = date

    if (!dt) {
        dt = new Date() // ** пустой параметр преобразовываем в текущую дату
    } else if (typeof date === 'string') {
        dt = parseISO(date) // ** передана дата в виде строки `год-месяц-день час:мин:сек`
    } else if (!!parseInt(dt)) {
        dt = new Date(date * 1000) // ** передан timestamp
    }

    if (dt == 'Invalid Date') return date

    const dateFnsLocale = getDateFnsLocale(locale)
    return format(dt, formatStr, {locale: dateFnsLocale})

}

/**
 * DEPRECATED. Use `formatDate` instead
 *
 * Собирает дату в строку
 * @param {Int} date  Приходит как timestamp
 * @param {String} format допустимые форматы `DD MMM YYYY | DDD MMM YYYY | DD MM YYYY`
 * @param {String} locale язык форматирования ru | en
 */
const dateFormater = (date, format = 'DD MMM YYYY', locale = 'ru') => {
    if (+date === 0) {
        return '-'
    }

    let monthsNames, dayNamesShort;
    switch (locale) {
        case 'en':
            monthsNames = monthsEng;
            dayNamesShort = daysEng;
            break;
        case 'ky':
            monthsNames = monthsKy;
            dayNamesShort = daysKy;
            break;
        default:
            monthsNames = months;
            dayNamesShort = days;
    }

    const dateForFormat = new Date(date * 1000);
    const year = dateForFormat.getFullYear();
    const dayN = formatNum(dateForFormat.getDate());
    const monthN = formatNum(dateForFormat.getMonth() + 1);
    const hours = formatNum(dateForFormat.getHours());
    const minutes = formatNum(dateForFormat.getMinutes());

    const monthName = monthsNames[dateForFormat.getMonth()];
    let dayIndex = dateForFormat.getDay() - 1;
    if (dayIndex < 0) dayIndex = 6;
    const dayName = dayNamesShort[dayIndex];

    switch (format) {
        case 'DD MMM YYYY':
            return `${dayN} ${monthName} ${year}`;
        case 'DDD MMM YYYY':
            return `${dayName} ${monthName} ${year}`;
        case 'DD MM YYYY':
            return `${dayN} ${monthN} ${year}`;
        case 'DD MM YYYY HH':
            return `${dayName}, ${dayN} ${monthN} ${year}, ${hours}:${minutes}`;
        default:
            return `${dayN} ${monthName} ${year}`;
    }
}

/**
 * Функция принимает два аргумента, массив в котором будет идти поиск и объект который требуется найти, также параметр поиска
 * @param {Array} array
 * @param {Object} payload
 * @param {*} prm
 */
const finder = (array, payload, prm = 'id') => {
    const finded = array.find(el => el[prm] === payload[prm]);

    return finded
}

/**
 * Функция трансформирует в объект для ответов
 * @param {Object} _data
 * @param {String} _key
 * @returns {{Array}}
 */
const prepareData = (_data, _key) => {
    const newdata = {}
    let idx = 0;

    for (const [key, value] of Object.entries(_data)) {
        const k = `${_key}[${idx}][name]`
        const v = `${_key}[${idx}][value]`
        newdata[k] = key
        newdata[v] = value

        idx++
    }

    return newdata
}

const getArrayByPage = (_arr, _size, _page) => {
    const page = _page - 1;

    return _arr.slice(_size * page, _size * page + _size)
}

const alphabet = ['Все', 'А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ё', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ь', 'Ы', 'Ъ', 'Э', 'Ю', 'Я', 'Специальные']

const formatNum = _num => _num > 9 ? _num : `0${_num}`
const base = import.meta.env.VITE_APP_BASE_API_URL

const formatImages = (html, book = 'null', id = 0, mode = 'system') => {
    if (!html) return ''

    html = html.toString()

    const regexp = /src="([^"]*)"/gi
    const payload = [...html.matchAll(regexp)]

    if (payload) {
        const store = useStore()
        let replacedHtml = html;

        payload.forEach(el => {
            if (el[1].startsWith('data:')) return

            if (!el[1].startsWith(base)) return

            let link = el[1].split('?')[0]

            if (book !== 'undefined' && book !== 'null') {
                book = JSON.parse(book)

                if (!link.match(/https:/)) {
                    link = `${base}pluginfile.php/${book.id}/mod_book/chapter/${book.chapter}/` + link
                }
            }

            link = link.replaceAll(`${base}pluginfile.php`, `${base}webservice/pluginfile.php`)
            link = link.replaceAll(`${base}tokenpluginfile.php`, `${base}webservice/pluginfile.php`)
            const src = `src="${link}"`
            replacedHtml = replacedHtml.replace(el[0], src)
        })

        if ((book !== 'undefined' && book !== 'null') || !/<pre/i.test(html)) {
            return replacedHtml
        }

        return initAceEditor(replacedHtml, id, mode)
    }

    if (!/<pre/i.test(html)) {
        return html
    }

    return initAceEditor(html, id, mode)
}

const formatLinks = (html) => {
    if (!html) return ''

    html = html.toString()

    const regexp = /href="([^"]*)"/gi
    const payload = [...html.matchAll(regexp)]

    if (payload) {
        let replacedHtml = html;

        payload.forEach(el => {
            let link = el[1].split('?')[0]

            link = link.replaceAll(`${base}pluginfile.php`, `${base}webservice/pluginfile.php`)
            link = link.replaceAll(`${base}tokenpluginfile.php`, `${base}webservice/pluginfile.php`)
            const src = `href="${link}"`

            replacedHtml = replacedHtml.replace(el[0], src)
        })

        return replacedHtml
    }

    return html
}

// ** элементы, отображаемые в ленте курса и на отдельной странице
const availableTypes = [
    'scorm',
    'quiz',
    'job',
    'url',
    'glossary',
    'feedback',
    'assign',
    'page',
    'forum',
    'book',
    'folder',
    'wiki',
    'resource',
    'yandexchat'
];

const checkSentry = () => {
    return import.meta.env.VITE_APP_SENTRY_DSN && import.meta.env.VITE_APP_SENTRY_DSN !==""
}

export {
    finder,
    formatNum,
    dateFormater,
    formatDate,
    prepareData,
    getArrayByPage,
    alphabet,
    formatImages,
    checkSentry,
    formatLinks,
    days,
    months,
    capitalize,
    monthsEng,
    monthsKy,
    daysEng,
    daysKy,
    availableTypes
}
